// extracted by mini-css-extract-plugin
export var cartIcon = "_ol-0";
export var cartIconContainer = "_ol-1";